import { render, staticRenderFns } from "./ActivityLogView.vue?vue&type=template&id=5585d8b2&scoped=true"
import script from "./ActivityLogView.vue?vue&type=script&lang=js"
export * from "./ActivityLogView.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogView.vue?vue&type=style&index=0&id=5585d8b2&prod&lang=scss&scoped=true"
import style1 from "./ActivityLogView.vue?vue&type=style&index=1&id=5585d8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585d8b2",
  null
  
)

export default component.exports